import SystemScreenInfoDialogHeaderTexts from "../texts/SystemScreenInfoDialogHeaderTexts";
import {kSystemIcons} from "../../constants/icons";
import {isNullOrUndefined} from "../../services/Validator";

export default function SystemScreenInfoHeader({handleClose, icon, title, isBrevet=false}) {
    // Used in screen info dialogs to display header made of
    // screen icon and name

    // BUILD
    if (isNullOrUndefined(handleClose) || isNullOrUndefined(icon) || isNullOrUndefined(title))
        return null
    return (
        <div className={"w-full flex justify-between items-center border-b-[1px] border-greyLight3 p-[16px]"}>
            <SystemScreenInfoDialogHeaderTexts icon={icon}
                                               title={title}
                                               isBrevet={isBrevet} />
            <div className={`cursor-pointer text-greyLight9 bg-backgroundLight4 hover:bg-backgroundLight5
                            w-[40px] min-w-[40px] h-[40px] min-h-[40px]
                            rounded-[8px] shadow-[inset_0_0_0_1px_#374356]
                            flex justify-center items-center`}
                 onClick={handleClose}>
                <i className="material-icons text-[20px]">
                    {kSystemIcons.close}
                </i>
            </div>
        </div>
    );
}